import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Perfil familiar", -1)
const _hoisted_2 = { class: "card my-5 my-xl-10" }
const _hoisted_3 = { class: "card-body pt-3 pt-md-9 pb-0 px-0 px-lg-9" }
const _hoisted_4 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-start flex-wrap" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = { class: "text-gray-900 fs-2 fw-bold me-1" }
const _hoisted_10 = { class: "d-flex gap-4 gap-lg-8 flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_11 = { class: "d-flex align-items-center text-gray-400 mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sitemap me-2" }, null, -1)
const _hoisted_13 = { class: "d-flex align-items-center text-gray-400 mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope me-2" }, null, -1)
const _hoisted_15 = { class: "d-flex align-items-center text-gray-400 mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt me-2" }, null, -1)
const _hoisted_17 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold" }
const _hoisted_18 = { class: "nav-item mt-2" }
const _hoisted_19 = { class: "nav-item mt-2" }
const _hoisted_20 = { class: "nav-item mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.familia?.nombre) + " " + _toDisplayString(_ctx.familia?.apellidos), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.familia?.comarca?.nombre), 1)
                  ]),
                  _createElementVNode("span", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.familia?.email), 1)
                  ]),
                  _createElementVNode("span", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.familia?.telefono), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_17, [
          _createElementVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              class: "nav-link text-active-primary me-5 me-lg-6",
              to: `informacion`,
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("familiaTabsInformacion")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createVNode(_component_router_link, {
              class: "nav-link text-active-primary me-5 me-lg-6",
              to: `menores`,
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("familiaTabsMenores")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createVNode(_component_router_link, {
              class: "nav-link text-active-primary",
              to: `servicios`,
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("familiaTabsServicios")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}